require("./vendors/vendors");

$(() => {

    /*
    |--------------------------------------------------------------------------
    | Variables
    |--------------------------------------------------------------------------
    */

    const _window = $(window);
    const body = $("body");
    const overlay = $(".overlay");


    /*
    |--------------------------------------------------------------------------
    | Button Loading
    |--------------------------------------------------------------------------
    */

    $("[data-loading]").on("click", (e) => {
        e.currentTarget.classList.add("btn-loading");
    });


    /*
    |--------------------------------------------------------------------------
    | Custom Select
    |--------------------------------------------------------------------------
    */

    const select = $(".custom-select-option");

    if (select.length) {
        select.niceSelect();

        select.on("change", (e) => {
            e.target.dispatchEvent(
                new Event("nice-select-updated", {
                    bubbles: true,
                })
            );
        });
    }


    /*
    |--------------------------------------------------------------------------
    | Header
    |--------------------------------------------------------------------------
    */

    const headerWrap = $(".header-wrap");
    const headerWrapInner = $(".header-wrap-inner");

    let headerWrapInnerHeight = headerWrapInner.outerHeight();

    const headerSearchSm = $(".header-search-sm");
    const searchInputSm = $(".search-input-sm");
    const headerSearchSmClose = $(
        ".header-search-sm-form .btn-close"
    );


    /*
    | Mobile Search
    */

    headerSearchSm.on("click", (e) => {
        const target = $(e.currentTarget);

        target
            .parents(".header-search")
            .next()
            .toggleClass("active");

        searchInputSm.focus();
    });


    headerSearchSmClose.on("click", (e) => {
        const target = $(e.currentTarget);

        target
            .parents(".header-search-sm-form")
            .removeClass("active");
    });


    /*
    | Header Resize
    */

    _window.on("resize", () => {
        headerWrapInnerHeight = headerWrapInner.outerHeight();
    });


    /*
    | Sticky Header
    */

    _window.on("load scroll resize", () => {

        if (!headerWrap.length || !headerWrapInner.length) {
            return;
        }

        const headerWrapHeight = headerWrap.outerHeight();

        const headerOffset = headerWrap.offset();

        if (!headerOffset) {
            return;
        }

        const headerWrapOffsetTop =
            headerOffset.top + headerWrapHeight;


        function stickyHeader() {

            const scrollTop = _window.scrollTop();

            if (scrollTop > headerWrapOffsetTop) {

                headerWrap.css(
                    "padding-top",
                    `${headerWrapInnerHeight}px`
                );

                headerWrapInner.addClass("sticky");

                setTimeout(() => {
                    headerWrapInner.addClass("show");
                });

                return;
            }

            headerWrap.css("padding-top", 0);

            headerWrapInner.removeClass(
                "sticky show"
            );
        }


        stickyHeader();
    });


    /*
    |--------------------------------------------------------------------------
    | Menu Dropdown Arrow
    |--------------------------------------------------------------------------
    */

    const megaMenuItem = $(".mega-menu > li");

    const subMenuDropdown = $(".sub-menu > .dropdown");

    const sidebarMenuSubMenu = $(".sidebar-menu .sub-menu");


    function menuDropdownArrow(
        parentSelector,
        childSelector
    ) {

        parentSelector.each(function () {

            const self = $(this);

            if (self.children().length <= 1) {
                return;
            }

            if (
                window.FleetCart &&
                window.FleetCart.rtl
            ) {

                self.children(
                    childSelector
                ).append(
                    '<i class="las la-angle-left"></i>'
                );

                return;
            }

            self.children(
                childSelector
            ).append(
                '<i class="las la-angle-right"></i>'
            );
        });
    }


    menuDropdownArrow(
        subMenuDropdown,
        "a"
    );

    menuDropdownArrow(
        megaMenuItem,
        ".menu-item"
    );


    /*
    |--------------------------------------------------------------------------
    | Sidebar Menu
    |--------------------------------------------------------------------------
    */

    const sidebarMenuIcon =
        $(".sidebar-menu-icon");

    const sidebarMenuWrap =
        $(".sidebar-menu-wrap");

    const sidebarMenuClose =
        $(".sidebar-menu-close");

    const sidebarMenuTab =
        $(".sidebar-menu-tab a");

    const sidebarMenuList =
        $(".sidebar-menu li");

    const sidebarMenuLink =
        $(".sidebar-menu > li > a");

    const sidebarMenuListUl =
        $(".sidebar-menu > li > ul");

    const sidebarMenuDropdown =
        $(".sidebar-menu > .dropdown");

    const sidebarMenuSubMenuUl =
        $(".sidebar-menu .sub-menu ul");

    const sidebarMenuSubMenuLink =
        $(".sidebar-menu .sub-menu > a");


    /*
    | Open Sidebar
    */

    sidebarMenuIcon.on("click", (e) => {

        e.stopPropagation();

        overlay.addClass("active");

        sidebarMenuWrap.addClass("active");
    });


    /*
    | Close Sidebar
    */

    sidebarMenuClose.on("click", () => {

        overlay.removeClass("active");

        sidebarMenuWrap.removeClass("active");
    });


    sidebarMenuWrap.on("click", (e) => {
        e.stopPropagation();
    });


    /*
    | Sidebar Tabs
    */

    sidebarMenuTab.on("click", (e) => {

        const target = $(e.currentTarget);

        e.preventDefault();

        target.tab("show");
    });


    /*
    | Sidebar Dropdown Arrows
    */

    sidebarMenuList.each(function () {

        const self = $(this);

        if (self.children().length <= 1) {
            return;
        }

        if (
            window.FleetCart &&
            window.FleetCart.rtl
        ) {

            self.children("a").after(
                '<i class="las la-angle-left"></i>'
            );

            return;
        }

        self.children("a").after(
            '<i class="las la-angle-right"></i>'
        );
    });


    /*
    | Sidebar Dropdown
    */

    sidebarMenuDropdown.on("click", (e) => {

        const target = $(e.currentTarget);

        if (!target.hasClass("active")) {

            $(".sidebar-menu > li")
                .removeClass("active");

            target.addClass("active");

        } else {

            $(".sidebar-menu > li")
                .removeClass("active");
        }


        if (
            !target
                .children("ul")
                .hasClass("open")
        ) {

            $(".sidebar-menu .open")
                .removeClass("open")
                .slideUp(300);

            target
                .children("ul")
                .addClass("open")
                .slideDown(300);

            return;
        }


        $(".sidebar-menu .open")
            .removeClass("open")
            .slideUp(300);
    });


    sidebarMenuLink.on("click", (e) => {
        e.stopPropagation();
    });


    sidebarMenuListUl.on("click", (e) => {
        e.stopPropagation();
    });


    sidebarMenuSubMenu.on("click", (e) => {

        const target = $(e.currentTarget);

        target.toggleClass("active");

        target
            .children("ul")
            .slideToggle(300);
    });


    sidebarMenuSubMenuUl.on("click", (e) => {
        e.stopPropagation();
    });


    sidebarMenuSubMenuLink.on("click", (e) => {
        e.stopPropagation();
    });


    /*
    |--------------------------------------------------------------------------
    | Property Hero / Home Slider
    |--------------------------------------------------------------------------
    */

    const homeSlider = $(".home-slider");

    if (homeSlider.length) {

        homeSlider
            .slick({

                rows: 0,

                rtl:
                    window.FleetCart &&
                    window.FleetCart.rtl,

                cssEase: "ease",

                speed: Number(
                    homeSlider.data("speed") || 500
                ),

                fade:
                    !!JSON.parse(
                        homeSlider.data("fade") || false
                    ),

                dots:
                    !!JSON.parse(
                        homeSlider.data("dots") || false
                    ),

                arrows:
                    !!JSON.parse(
                        homeSlider.data("arrows") || false
                    ),

                autoplay:
                    !!JSON.parse(
                        homeSlider.data("autoplay") || false
                    ),

                autoplaySpeed:
                    Number(
                        homeSlider.data(
                            "autoplay-speed"
                        ) || 5000
                    ),

                responsive: [
                    {
                        breakpoint: 768,

                        settings: {
                            dots: false,
                        },
                    },
                ],
            })
            .slickAnimation();
    }


    /*
    |--------------------------------------------------------------------------
    | Tooltip
    |--------------------------------------------------------------------------
    */

    if ($('[data-toggle="tooltip"]').length) {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: "hover",
            selector: '[data-toggle="tooltip"]',
        });
    }


    /*
    |--------------------------------------------------------------------------
    | Property Filters
    |--------------------------------------------------------------------------
    */

    const mobileViewFilter =
        $(".mobile-view-filter");

    const filterSectionWrap =
        $(".filter-section-wrap");

    const sidebarFilterClose =
        $(".sidebar-filter-close");


    mobileViewFilter.on("click", (e) => {

        e.stopPropagation();

        filterSectionWrap.addClass("active");

        overlay.addClass("active");
    });


    sidebarFilterClose.on("click", () => {

        filterSectionWrap.removeClass("active");

        overlay.removeClass("active");
    });


    filterSectionWrap.on("click", (e) => {
        e.stopPropagation();
    });


    /*
    |--------------------------------------------------------------------------
    | Close Overlay Panels
    |--------------------------------------------------------------------------
    */

    body.on("click", () => {

        overlay.removeClass("active");

        sidebarMenuWrap.removeClass("active");

        filterSectionWrap.removeClass("active");
    });


    /*
    |--------------------------------------------------------------------------
    | Property Image Gallery
    |--------------------------------------------------------------------------
    */

    const baseImage = $(".base-image");

    const additionalImageWrap =
        $(".additional-image-wrap");


    /*
    | Additional Images
    */

    if (
        additionalImageWrap.length &&
        baseImage.length
    ) {

        additionalImageWrap.slick({

            rows: 0,

            dots: false,

            arrows: true,

            vertical: true,

            infinite: false,

            slidesToShow: 4,

            slidesToScroll: 1,

            asNavFor: baseImage,

            focusOnSelect: true,

            adaptiveHeight: true,

            verticalSwiping: true,

            responsive: [
                {
                    breakpoint: 577,

                    settings: {

                        vertical: false,

                        variableWidth: true,

                        verticalSwiping: false,

                        rtl:
                            window.FleetCart &&
                            window.FleetCart.rtl,
                    },
                },
            ],
        });
    }


    /*
    | Main Property Image
    */

    if (baseImage.length) {

        baseImage.slick({

            rows: 0,

            fade: true,

            dots: false,

            swipe: false,

            arrows: false,

            infinite: false,

            draggable: false,

            slidesToShow: 1,

            slidesToScroll: 1,

            rtl:
                window.FleetCart &&
                window.FleetCart.rtl,
        });


        /*
        | Lightbox
        */

        if (
            typeof baseImage.slickLightbox ===
            "function"
        ) {

            baseImage.slickLightbox({

                src: "data-image",

                itemSelector:
                    ".base-image-slide",

                slick: {

                    fade: true,

                    infinite: false,

                    rtl:
                        window.FleetCart &&
                        window.FleetCart.rtl,
                },
            });
        }


        /*
        | Image Zoom
        */

        $(".base-image-slide").zoom({
            magnify: 1.2,
            touch: false,
        });
    }

});